import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        user
    },
    mutations: {
        logout (state) {
            this.commit('user/logout');
        }
    },
    strict: debug,
})



// WEBPACK FOOTER //
// ./src/store/index.js